const { gql } = require('@apollo/client/core')

const build = (tasks) => {
    return tasks.map((task) => {
        task.inputName = `${task.id}V${task.version}Input`
        task.inputOutputName = `${task.id}V${task.version}InputOutput`
        task.outputName = `${task.id}V${task.version}Output`
        task.taskName = `${task.id}V${task.version}`
        task.enqueueMutationName = `enqueue${task.taskName}`

        return task
    })
}

module.exports = build([
    {
        id: 'Test',
        version: 1,
        input: null,
        output: gql`{ value }`
    },
    {
        id: 'Test',
        version: 2,
        input: null,
        output: gql`{ value }`
    },
    {
        id: 'ExportCustomers',
        version: 1,
        input: null,
        output: gql`{ csvUrl, xlsxUrl, xmlUrl, jsonUrl }`
    },
    {
        id: 'ExportProperties',
        version: 1,
        input: null,
        output: gql`{ csvUrl, xlsxUrl, xmlUrl, jsonUrl }`
    }
])


// WEBPACK FOOTER //
// ./resources/assets/javascript/components/queue/registry.js